"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

class Currencies {
  constructor(provider) {
    this.apiProvider = void 0;
    this.api = void 0;

    this.tokens = () => {
      return (0, _rxjs.of)([{
        name: 'LAMI',
        symbol: 'LAMI',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: true,
        id: 'LAMI'
      }, {
        name: 'USD',
        symbol: 'AUSD',
        precision: 18,
        isBaseToken: true,
        isNetworkToken: false,
        id: 'AUSD'
      }, {
        name: 'EUR',
        symbol: 'FEUR',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FEUR'
      }, {
        name: 'JPY',
        symbol: 'FJPY',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FJPY'
      }, {
        name: 'BTC',
        symbol: 'FBTC',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FBTC'
      }, {
        name: 'ETH',
        symbol: 'FETH',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FETH'
      }, {
        name: 'AUD',
        symbol: 'FAUD',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FAUD'
      }, {
        name: 'CAD',
        symbol: 'FCAD',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FCAD'
      }, {
        name: 'CHF',
        symbol: 'FCHF',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FCHF'
      }, {
        name: 'XAU',
        symbol: 'FXAU',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FXAU'
      }, {
        name: 'OIL',
        symbol: 'FOIL',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: 'FOIL'
      } // {
      //   name: 'FGBP',
      //   symbol: 'GBP',
      //   precision: 18,
      //   isBaseToken: false,
      //   isNetworkToken: false,
      //   id: 'FGBP'
      // }
      ]);
    };

    this.balances = address => {
      return this.tokens().pipe((0, _operators.switchMap)(tokens => {
        return (0, _rxjs.combineLatest)(...tokens.map(({
          id
        }) => this.api.derive.currencies.balance(address, id).pipe((0, _operators.map)(result => {
          return {
            tokenId: id,
            free: result.toString()
          };
        }))));
      }));
    };

    this.oracleValues = dataProviderId => {
      return this.api.rpc.chain.subscribeNewHeads().pipe((0, _operators.switchMap)(() => this.tokens()), (0, _operators.switchMap)(tokens => {
        return (0, _rxjs.combineLatest)(tokens.filter(token => !token.isNetworkToken && !token.isBaseToken).map(({
          id
        }) => this.api.rpc.oracle.getValue(dataProviderId, id).pipe((0, _operators.map)(result => {
          return [id, result];
        }))));
      }), (0, _operators.map)(values => {
        return values.map(([tokenId, curr]) => {
          const result = {
            tokenId
          };

          if (!curr.isEmpty) {
            result.timestamp = curr.value.timestamp.toNumber();
            result.value = curr.value.value.toString();
          }

          return result;
        });
      }));
    };

    this.transfer = async (account, dest, tokenId, amount) => {
      const extrinsic = this.api.tx.currencies.transfer(dest, tokenId, amount);
      return this.apiProvider.extrinsicHelper(extrinsic, account, {
        action: 'Transfer'
      });
    };

    this.apiProvider = provider;
    this.api = provider.api;
  }

}

var _default = Currencies;
exports.default = _default;